import { themesService } from '@services/ThemesService';

enum ThemeNames {
    DarkTheme = 'DarkTheme',
    LightTheme = 'LightTheme',
}

export const getClassNameWithTheme = (className: string) =>
    `${themesService.isDarkTheme ? ThemeNames.DarkTheme : ThemeNames.LightTheme} ${className}`;
